import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Card,
  IconButton,
  CardContent,
  ThemeProvider,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import "../MuiTable.scss";
import "react-toastify/dist/ReactToastify.css";
import { MuiDataTableTheme } from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import Page from "../../../../../Components/Dashboard/Page";
import CardAllSubSkills from "../../../../../sections/@dashboard/app/CardAllSubSkills";
import CardActiveSkills from "../../../../../sections/@dashboard/app/CardActiveSkills";
import CardAllSkills from "../../../../../sections/@dashboard/app/CardAllSkills";
import CardInactiveSkills from "../../../../../sections/@dashboard/app/CardInactiveSkills";
import MUIDataTable from "mui-datatables";
import { colors } from "../../../../../Styles/GlobalStyles/Variables";
import ArchiveIcon from "@mui/icons-material/Archive";
import StatusGenerator from "../../../../../Components/StatusGenerator/StatusGenerator";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import moment from "moment";
import DialogBox from "../../../../../Components/DialogBox/DialogBox";
import { ElevatedGreenButton } from "../../../../../Components/Button/CustomButton";
import ConfirmDialog from "../../../../../Components/Alert/ConfirmDialog";
import { ColumnTextStyle } from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import {
  StyledTableCell,
  ViewIcon,
  EditIcon,
  ActivateIcon,
  DeactivateIcon,
  AddIcon,
} from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import {
  components,
  PrintButtonIcon,
} from "../../../../../Components/Icons/DataTableIcons";
import AddNewSkillDialogForm from "../../../../../Components/SkillSetUp/AddNewSkillDialogForm";
import AddSubSkillDialog from "../../../../../Components/SkillSetUp/AddSubSkillDialog";
import {
  fetchSkillSet,
  activateSkillSet,
  deactivateSkillSet,
  restoreSkillSetInitial,
  fetchSkillSetById,
  fetchSubSkillBySkillId,
  fetchAllTotalSkillsData,
  exportSkillFile,
  fetchSkillSelect,
  emptySkillSelect,
  updateSubSkill,
} from "../../../../../Actions";
import LoadingOverlay from "react-loading-overlay-ts";
import ViewSkillDialog from "../../../../../Components/SkillSetUp/ViewSkillDialog";
import { EmptyRowIcon } from "../../../../../Components/Icons/EmptyRowIcon";
import Searchbox from "../../../../../Components/Dashboard/Searchbox";
import { useDebounce } from "../../../../../Hooks/useDebounce";
import PrintTemplate from "../../../../../Components/PrintFiles/PrintTemplate";
import { clearMsg, infoMsg } from "../../../../../Utils/apiToasts";
import FilterButton from "../../../../../Components/Button/FilterButton";
import EditSubSkillDialog from "../../../../../Components/SkillSetUp/EditSubSkillDialog";

const getState = (state) => state.skillsReducer;
const getSkillSelectState = (state) => state.skillSelectReducer;
const usersReducer = (state) => state.usersReducer;
LoadingOverlay.propTypes = undefined;

const SkillSetUp = () => {
  const [openDialog, setOpenDialog] = useState({
    open: false,
    Title: "",
    Content: null,
    actionButton: "",
  });
  const {
    allSkillSetCreated,
    skillSetActivated,
    skillSetDeactivated,
    skillSet,
    isLoading,
    savingSubskillUpdate,
    subSkillUpdated,
  } = useSelector(getState);

  const { authUser } = useSelector(usersReducer);
  const dispatch = useDispatch();

  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const { skillSelectFetched, isFetched } = useSelector(getSkillSelectState);
  const [allSubSkill, setAllSubSkill] = useState([]);
  const [skillSetTableData, setSkillSetTableData] = useState([]);
  const [openNewSkillDialog, setOpenNewSkillDialog] = useState(false);
  const [openViewSkillDialog, setOpenViewSkillDialog] = useState(false);
  const [openNewSubSkillDialog, setOpenNewSubSkillDialog] = useState(false);
  const [subSkillId, setSubSkillId] = useState(0);
  const [formType, setFormType] = useState("");
  const [loading, setLoading] = useState(true);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [searchText, setSearchText] = useState("");
  const [filterOptions, setFilterOptions] = useState("");
  const [filters, setFilters] = useState({});
  const debouncedSearchText = useDebounce(searchText, 300);
  const [loadPrint, setLoadPrint] = useState(false);
  const [curSubSkill, setCurSubSkill] = useState(null);
  const [editSubSkillDialogIsOpen, setEditSubSkillDialogIsOpen] =
    useState(false);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
    note: false,
  });

  const theParams = {
    PageNumber: pageNumber,
    PageSize: pageSize,
    Search: searchText,
    "FilterOptions.Status": filterOptions.status,
  };
  const handleFilterClick = (event) => {
    if (event !== 0) {
      setLoading(true);
      setFilters(event);
      setFilterOptions(event);
    }
  };

  const handleReset = (event) => {
    if (filterOptions !== "") {
      setLoading(true);
      setFilterOptions("");
      setFilters("");
    }
  };
  const options = [
    {
      name: "status",
      type: "radio",
      group: "Status",
      options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Active",
          value: true,
        },
        {
          label: "Inactive",
          value: false,
        },
      ],
    },
  ];

  const printIdCardArea = () => {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.srcdoc = document.getElementById("printarea").innerHTML;
    document.body.appendChild(iframe);
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    iframe.contentWindow.close();
    iframe.style.display = "none";
    clearMsg();
  };

  const fireApi = () => {
    return dispatch(fetchSkillSelect());
  };
  const printSkillsPdf = async () => {
    await fireApi();
    infoMsg("Loading the print preview window...");
    setShowPrintPreview(true);
    setLoadPrint(true);
  };

  useEffect(() => {
    if (skillSelectFetched.length > 0 && showPrintPreview === true) {
      printIdCardArea();
      setShowPrintPreview(false);
      setLoadPrint(false);
    }
  }, [skillSelectFetched, showPrintPreview]);

  useEffect(() => {
    if (!showPrintPreview) {
      dispatch(emptySkillSelect());
    }
  }, [showPrintPreview, dispatch]);

  const handleOpenNewSkillDialog = () => {
    setOpenNewSkillDialog(true);
  };

  const handleOpenNewSubSkillDialog = (id) => {
    setOpenNewSubSkillDialog(true);
    setSubSkillId(() => id);
  };

  const handleOpenViewSkillDialog = (id) => {
    setFormType("view");
    setOpenViewSkillDialog(true);
    dispatch(fetchSkillSetById(id));
    dispatch(fetchSubSkillBySkillId(id));
  };

  const handleOpenEditSkillDialog = (id) => {
    setFormType("edit");
    setOpenViewSkillDialog(true);
    dispatch(fetchSkillSetById(id));
    dispatch(fetchSubSkillBySkillId(id));
  };

  const updateLoadingState = () => {
    setLoading(true);
  };

  const handleCloseNewSkillDialog = () => {
    setOpenNewSkillDialog(false);
  };

  const handleCloseNewSubSkillDialog = () => {
    setOpenNewSubSkillDialog(false);
  };

  const handleCloseViewSkillDialog = () => {
    setOpenViewSkillDialog(false);
    let params = {};
    params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      Search: debouncedSearchText,
      "FilterOptions.Status": filterOptions.status,
    };
    //  }
    dispatch(fetchSkillSet(params));
  };

  const activateSkill = (id) => {
    dispatch(activateSkillSet(id));
    setLoading(true);
    setConfirmDialog({
      ...confirmDialog,
      isLoading: true,
    });
  };

  const deactivateSkill = (id) => {
    dispatch(deactivateSkillSet(id));
    setLoading(true);
    setConfirmDialog({
      ...confirmDialog,
      isLoading: true,
    });
  };

  const handleOpenEditSubSkillDialog = (subskill) => {
    setCurSubSkill({
      ...subskill,
    });
    setEditSubSkillDialogIsOpen(true) 
  };

  const handleCloseUpdateSubSkillDialog = () => {
    setEditSubSkillDialogIsOpen(false)
  }

  const handleEditSubSkill = (newSubSkillData) => {
    const payload = {
      name: newSubSkillData.name,
      subSkillid: newSubSkillData.id
    }
    dispatch(updateSubSkill(payload))
  }

  useEffect(() => {
    if (subSkillUpdated === true) {
      setEditSubSkillDialogIsOpen(false)
      const params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: debouncedSearchText,
        "FilterOptions.Status": filterOptions.status,
      };
      dispatch(fetchSkillSet(params));
    }
  
  }, [subSkillUpdated])
  

  useEffect(() => {
    if (skillSetActivated === true) {
      setLoading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        "FilterOptions.Status": filterOptions.status,
      };
      setConfirmDialog({
        ...confirmDialog,
        isLoading: false,
        isOpen: false,
      });
      dispatch(fetchSkillSet(params));
      dispatch(fetchAllTotalSkillsData());
    }
    return () => {
      dispatch(restoreSkillSetInitial());
    };
  }, [skillSetActivated]);

  useEffect(() => {
    if (skillSetDeactivated === true) {
      setConfirmDialog({
        ...confirmDialog,
        isLoading: false,
        isOpen: false,
      });
      setLoading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        "FilterOptions.Status": filterOptions.status,
      };
      dispatch(fetchSkillSet(params));
      dispatch(fetchAllTotalSkillsData());
    }
    return () => {
      dispatch(restoreSkillSetInitial());
    };
  }, [skillSetDeactivated]);

  //effect handling the API dispatch for pagination
  useEffect(() => {
    let params = {};
    params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      Search: debouncedSearchText,
      "FilterOptions.Status": filterOptions.status,
    };
    //  }
    dispatch(fetchSkillSet(params));
    dispatch(fetchAllTotalSkillsData());
  }, [dispatch, pageNumber, pageSize, debouncedSearchText, filterOptions]);

  // effect used to populate table data
  useEffect(() => {
    if (allSkillSetCreated && Object.keys(allSkillSetCreated)?.length !== 0) {
      const createTableData = () => {
        let skillSetTableData = [];
        let allSkillSetCreatedData = allSkillSetCreated?.data;

        allSkillSetCreatedData?.map((val) => {
          let row = [
            val.name,
            val.subSkills.length,
            val.dateCreated,
            val.dateModified,
            val.isActive,
            val,
          ];
          return skillSetTableData.push(row);
        });
        setSkillSetTableData(skillSetTableData);
        setLoading(false);
        setShowNoDataMessage(false);
      };
      Object.keys(allSkillSetCreated).length > 0 && createTableData();
    } else {
      setSkillSetTableData([]);
    }
  }, [allSkillSetCreated, pageNumber]);

  const changePage = (page) => {
    setLoading(true);
    setPageNumber(page);
  };

  useEffect(() => {
    if (
      isLoading === false &&
      (Object.keys(allSkillSetCreated)?.length === 0 ||
        allSkillSetCreated?.data?.length === 0)
    ) {
      setShowNoDataMessage(true);
      setLoading(false);
    } else {
      setShowNoDataMessage(false);
    }
  }, [isLoading, allSkillSetCreated]);

  // useEffect(() => {
  // if (allSkillSetCreated && Object.keys(allSkillSetCreated).length !== 0) {
  let paginationOptions = {
    filter: false,
    searchPlaceholder: "Search for Skill Set",
    searchText: searchText,
    search: false,
    debounceSearchRender: 500,
    selectableRows: "none",
    expandableRows: true,
    expandableRowsHeader: false,
    print: false,
    expandableRowsOnClick: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    count: allSkillSetCreated?.meta?.totalCount,
    serverSide: true,
    // filter: false,
    page: pageNumber - 1,
    onDownload: (buildHead, buildBody, columns, data) => {
      dispatch(exportSkillFile());
      return false;
    },
    jumpToPage: true,
    customToolbar: () => {
      return (
        <>
          <Tooltip title="Print Table">
            <IconButton onClick={printSkillsPdf}>
              {loadPrint ? <CircularProgress size={24} /> : <PrintButtonIcon />}
            </IconButton>
          </Tooltip>

          <FilterButton
            options={options}
            filters={filters}
            onClick={handleFilterClick}
            reset={handleReset}
          />

          {
            authUser.role ===
              "SAED_NDHQ" &&(
                <ElevatedGreenButton
                  onClick={handleOpenNewSkillDialog}
                  startIcon={<AddOutlinedIcon />}
                >
                  Add New Skill
                </ElevatedGreenButton>
              )}
        </>
      );
    },

    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setLoading(true);
        changePage(tableState.page + 1);
        return () => {
          setLoading(false);
        };
      }

      if (action === "rowExpansionChange") {
        let rowName = [];
        let rowIndex = tableState.curExpandedRows[0].index;
        rowName = tableState.data[rowIndex].data[5].subSkills;
        if (allSubSkill === "") {
          setAllSubSkill(rowName);
        } else if (rowName === allSubSkill) {
          setAllSubSkill([]);
        } else {
          return;
        }
      }
    },
    renderExpandableRow: (rowData, rowMeta, an) => {
      const colSpan = rowData?.length + 1;
      const index = rowMeta?.rowIndex;
      let allSkillSetCreatedData = allSkillSetCreated?.data;
      const mySubskills =
        allSkillSetCreatedData && allSkillSetCreatedData[index]
          ? allSkillSetCreatedData[index].subSkills
          : undefined;
      if (mySubskills?.length === 0) {
        // return null
      }
      return (
        <tr>
          <td colSpan={colSpan}>
            <TableContainer>
              <Table
                size="small"
                style={{
                  width: "100%",
                  borderLeft: "3px solid #545856",
                  backgroundColor: "#F5F9F7",
                }}
                aria-label="simple table"
              >
                <TableBody>
                  {mySubskills &&
                    mySubskills?.length > 0 &&
                    mySubskills?.map((subskill) => {
                      return (
                        <TableRow key={subskill.id}>
                          <StyledTableCell>
                            {subskill.name}
                            <Tooltip title={"Edit Sub-skill"} style={{
                              marginLeft: "30px"
                            }}>
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleOpenEditSubSkillDialog(subskill)
                                }
                              >
                                <EditIcon icon="icon-park-outline:edit" />
                              </IconButton>
                            </Tooltip>
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </td>
        </tr>
      );
    },

    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
      />
    ),
    disableRipple: true,
    elevation: 0,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    // tableBodyHeight: "600px",
    tableBodyMinHeight: "600px",
    tableBodyMaxHeight: "1000px",
    // rowsPerPageOptions: [10, 50, 100],

    textLabels: {
      body: {
        noMatch: showNoDataMessage ? <EmptyRowIcon /> : "",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Download sheet",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  const columns = [
    {
      name: "skill",
      label: "Skills",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        filter: false,
      },
    },
    {
      name: "subSkillNo",
      label: "No of Sub Skills",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null ? (
            0
          ) : (
            <p style={{ textAlign: "center" }}>{value}</p>
          );
        },
        filter: false,
      },
    },
    {
      name: "datecreated",
      label: "Date Created",
      options: {
        filter: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === ""
            ? ""
            : moment(value).format("DD/MM/YYYY");
        },
      },
    },
    {
      name: "dateactivated",
      label: "Date Activated",
      options: {
        filter: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === ""
            ? ""
            : moment(value).format("DD/MM/YYYY");
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        sort: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          switch (value) {
            case true:
              return (
                <StatusGenerator statusText="Active" variant="greenFilled" />
              );
            case false:
              return (
                <StatusGenerator statusText="Inactive" variant="redFilled" />
              );
            default:
              return "no status";
          }
        },
        filter: true,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Tooltip title={"View Skill"}>
                <IconButton
                  size="small"
                  onClick={() =>
                    handleOpenViewSkillDialog(tableMeta.rowData[5].id)
                  }
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>

              {authUser.role !== "SAED_State" &&
                authUser.role !== "SAED_State_Coordinator" &&
                authUser.role !== "SAED_LGI" && (
                  <>
                    <Tooltip title={"Edit Skill"}>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenEditSkillDialog(value.id)}
                      >
                        <EditIcon icon="icon-park-outline:edit" />
                      </IconButton>
                    </Tooltip>
                    {value.isActive === false ? (
                      <Tooltip title={"Activate Skill"}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmDialog({
                              isOpen: true,
                              note: true,
                              title: `Are you sure you want to activate ${value.name} skill?`,
                              header: `Activate ${value.name} Skill`,
                              subTitle:
                                "Activating this skill means you are activating all subskills",
                              backgroundColor: colors.successDialogBg,
                              borderSideColor: colors.darkSuccessDialog,
                              color: colors.primaryGreen,
                              subColor: colors.successDialogSubTitle,
                              onConfirm: () => {
                                activateSkill(value.id);
                              },
                            })
                          }
                        >
                          <ActivateIcon icon="fluent-mdl2:activate-orders" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Deactivate Skill"}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmDialog({
                              isOpen: true,
                              note: true,
                              title: `Are you sure you want to deactivate ${value.name} skill?`,
                              header: `Deactivate ${value.name} Skill `,
                              subTitle:
                                "Deactivating this skill means you are deactivating all subskills under it",
                              backgroundColor: colors.errorDialogBg,
                              borderSideColor: colors.darkerErrorDialog,
                              color: colors.darkerErrorDialog,
                              subColor: colors.darkerErrorDialog,
                              onConfirm: () => {
                                deactivateSkill(value.id);
                              },
                            })
                          }
                        >
                          <DeactivateIcon icon="fluent-mdl2:deactivate-orders" />
                        </IconButton>
                      </Tooltip>
                    )}

                    <Tooltip title={"Add Sub Skill"}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleOpenNewSubSkillDialog(value.id);
                        }}
                      >
                        <AddIcon icon="fluent:add-square-multiple-20-regular" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
            </>
          );
        },
      },
    },
  ];

  const displayData = [
    { status: true },
    { status: false },
    { status: true },
    { status: false },
  ];

  const handleChange = (e) => {
    let searchValue = e.target.value;
    setSearchText(searchValue);
  };

  const CustomToolbarSelect = () => {
    const handleClickArchive = () => {
      // this.props.setSelectedRows([]);
    };
    return (
      <div style={{ marginRight: " 24px" }}>
        <Tooltip title={`Archive ${columns[0]?.name}`}>
          <IconButton onClick={handleClickArchive}>
            <ArchiveIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  return (
    <Page title="SAED | Skill Set Up">
      <Container maxWidth="xl">
        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#212B36" }}
          >
            Skill Set Management
          </Typography>
        </Box>
        <Box sx={{ pb: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md>
              <CardAllSkills />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardAllSubSkills />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardActiveSkills />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardInactiveSkills />
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Paper
                sx={{
                  boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                  borderRadius: "20px",
                }}
              >
                <Card
                  elevation={0}
                  sx={{ padding: "0px !important", borderRadius: "20px" }}
                >
                  <CardContent sx={{ padding: "0px !important" }}>
                    <ThemeProvider theme={MuiDataTableTheme}>
                      <LoadingOverlay
                        active={loading}
                        styles={{
                          overlay: (base) => ({
                            ...base,
                            background: "rgba(0, 0, 0, 0.15)",
                          }),
                        }}
                        spinner
                        text="Fetching Data for You..."
                      >
                        <MUIDataTable
                          title={
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={10}
                              justifyContent="space-between"
                            >
                              <Typography
                                sx={{ color: "#05004E", fontWeight: 600 }}
                              >
                                Skill Set-up
                              </Typography>
                              <Searchbox
                                placeholder="Skill Set"
                                onChange={handleChange}
                                value={searchText}
                              />
                            </Box>
                          }
                          data={skillSetTableData}
                          columns={columns}
                          options={paginationOptions}
                          components={components}
                          displayData={displayData}
                          style={{ transition: "0.7s" }}
                        />
                      </LoadingOverlay>
                    </ThemeProvider>
                  </CardContent>
                </Card>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <div id="printarea" style={{ display: "none" }}>
        <PrintTemplate />
      </div>
      <DialogBox openDialog={openDialog} setOpenDialog={setOpenDialog} />
      <AddNewSkillDialogForm
        openNewSkillDialog={openNewSkillDialog}
        handleCloseNewSkillDialog={handleCloseNewSkillDialog}
        updateLoadingState={updateLoadingState}
      />
      <AddSubSkillDialog
        openNewSubSkillDialog={openNewSubSkillDialog}
        handleCloseNewSubSkillDialog={handleCloseNewSubSkillDialog}
        updateLoadingState={updateLoadingState}
        subSkillId={subSkillId}
        theParams={theParams}
      />
      <ViewSkillDialog
        openViewSkillDialog={openViewSkillDialog}
        handleCloseViewSkillDialog={handleCloseViewSkillDialog}
        skillSet={skillSet}
        formType={formType}
        updateLoadingState={updateLoadingState}
        theParams={theParams}
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <EditSubSkillDialog
        open={editSubSkillDialogIsOpen}
        handleClose={handleCloseUpdateSubSkillDialog}
        subSkillData={curSubSkill}
        handleSubmit={handleEditSubSkill}
        loading={savingSubskillUpdate}
      />
    </Page>
  );
};

export default SkillSetUp;
